import * as Sentry from '@sentry/vue'

import {
  type NewsletterRegisterBody,
  type NewsletterRegisterResponse,
} from '@layers/web/services/types/newsletter-api.ts'
import { CACHE_KEYS } from '@layers/web/constants/cache.ts'

export class NewsletterApiService {
  static async fetchNewsletterLists (): Promise<string[]> {
    try {
      const { market } = useRuntimeConfig().public
      const { data: res } = await serverCacheStaleWhileRevalidate(
        CACHE_KEYS.NEWSLETTER_LISTS,
        () => apiFetch<string[]>(
          `/${market}/newsletter-lists`,
          { retryDelay: 5000 }
        ),
        { retryDelayMs: 5000 }
      )
      return res
    } catch (error: any) {
      Sentry.setContext('details', error.data)
      Sentry.captureException(new Error('Failed to fetch newsletter lists'), {
        level: 'error',
        tags: {
          operation: 'fetchNewsletterLists',
          service: 'newsletter-api',
        },
      })

      throw error
    }
  }

  static async registerNewsletterCampaign (body: NewsletterRegisterBody, campaign: string): Promise<NewsletterRegisterResponse> {
    const { market } = useRuntimeConfig().public
    const { data: res } = await apiFetch<NewsletterRegisterResponse>(`/${market}/newsletter-register?campaign=${campaign}`, {
      method: 'POST',
      body,
    })
    return res
  }

  static async registerNewsletter (body: NewsletterRegisterBody): Promise<NewsletterRegisterResponse> {
    const { market } = useRuntimeConfig().public
    const { data: res } = await apiFetch<NewsletterRegisterResponse>(`/${market}/newsletter-register`, {
      method: 'POST',
      body,
    })
    return res
  }
}
